import { ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Component } from '@angular/core';
import { Category } from '../../models/Category';
import { faXmark, faX, faArrowDown, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { FilterListObject } from '../../models/FilterListObject';

@Component({
  selector: 'app-category-tree',
  standalone: false,
  templateUrl: './category-tree.component.html',
  styleUrl: './category-tree.component.css'
})
export class CategoryTreeComponent {
  @Input() cat: Category;
  @Input() IsTolomaticUser: boolean;
  @Output() EditCategoryClick = new EventEmitter<Category>();
  @Output() DeleteCategoryClick = new EventEmitter<Category>();
  @Output() DocTypeChange = new EventEmitter<FilterListObject>();  
  faXmark = faXmark;
  faX = faX;
  faArrowDown = faArrowDown;
  faPenToSquare = faPenToSquare;

  public constructor(private elementRef:ElementRef) {

  }

  EditCategory(){
    //this.EditCategoryClick.emit(this.cat);
    const event: CustomEvent = new CustomEvent('CategoryTreeEditEvent', {
      bubbles: true,
      detail: this.cat
    });
    this.elementRef.nativeElement.dispatchEvent(event);
  }

  DeleteCategory(toDelete:Category) {
    //this.DeleteCategoryClick.emit(toDelete);
    const event: CustomEvent = new CustomEvent('CategoryTreeDeleteEvent', {
      bubbles: true,
      detail: this.cat.CategoryID
    });
    this.elementRef.nativeElement.dispatchEvent(event);
    
  }

  chkDocType_Change(ev:any) {
    var flObject = new FilterListObject();

    flObject.Value = this.cat.CategoryID.toString();
    flObject.Desc = this.cat.Name;
    flObject.Selected = ev.target.checked;
    this.DocTypeChange.emit(flObject);
  }
}
